export default {
  component: () => import('./page.vue'),
  path: '/profile',
  name: 'profile',
  meta: {
    title: '个人资料',
    auth: true,
  },
};
